<template>
	<form class="pallet-form" :action="production['@id']" axiosMethod="patch" ref="palletForm">
		<CRow alignHorizontal="center" alignVertical="center">
			<h5>Changer de palette</h5>
			<CSelect
				class="pallet-select"
				name="pallet"
				v-model="palletIri"
				placeholder="Sélectionnez..."
				:options="palletOptions"
				ref="pallet"
				:value.sync="palletIri"
				required />
			<CButton color="primary" v-on:click="onSubmit($refs.palletForm)">Changer</CButton>
		</CRow>
	</form>
</template>

<script>
	export default {
		props: {
			production: Object,
		},
		data: function () {
			return {
				palletIri: null,
				palletOptions: [],
			};
		},
		watch: {
			production: {
				immediate: true,
				handler: function (newVal) {
					this.getPendingPalletsForCurrentFlight();
				},
			},
		},
		methods: {
			getPendingPalletsForCurrentFlight() {
				this.$axios.get(`${this.production.flight['@id']}/pallets?state=pallet.pending`).then(res => {
					if (res.status === 200) {
						const pallets = res.data['hydra:member'];
						this.palletOptions = [];
						this.palletOptions = pallets.map(item => {
							return {
								label: item.reference,
								value: item['@id'],
							};
						});
					} else {
						this.$toast.error(
							"Une erreur s'est produite, certaines fonctionnalitées " +
								'peuvent ne pas fonctionner correctement, contactez un administrateur'
						);
					}
				});
			},
			onSubmit(form) {
				this.$formDataToApi.sendForm(form).then(res => {
					if (res.status === 200 || res.status === 201) {
						this.$toast.success('Nouvelle palette appliquée !');
						this.$emit('submit', res.data);
					} else {
						this.$toast.error(res.data['hydra:description']);
					}
				});
			},
		},
	};
</script>

<style>
	.pallet-select {
		max-width: 142px;
		margin: 0 20px;
	}
</style>
